// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"DcDxZK","WithHeader":"iPBCn_"};